export default __webpack_public_path__ + "static/media/calender-icon-side-right.624bd07f.svg";